var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"tag"},[_c('a',{class:_vm.active ? 'selected' : '',attrs:{"title":_vm.name,"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.toggle($event)}}},[_c('span',[_vm._v(_vm._s(_vm.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }